module.exports = __webpack_public_path__ + "static/img/lily.b5c1337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff-images/lily.jpg
// module id = lP4p
// module chunks = 0